import { Observable } from 'rxjs';

import apiService, { ApiService } from '../../api';
import ICoreTranslationValue from '../../../interfaces/models/core/i18n/translation-value';

export class CoreI18nService {
  private baseServiceUrl = '/core/i18n';

  constructor(private apiService: ApiService) {}

  public getPublicValues(): Observable<ICoreTranslationValue[]> {
    return this.apiService.get(`${this.baseServiceUrl}/`);
  }

  public valuesByKey(id: string): Observable<ICoreTranslationValue[]> {
    return this.apiService.get(`${this.baseServiceUrl}/${id}`);
  }

  public getLanguageValue(values: ICoreTranslationValue[], language: string): string {
    return values.find(val => val.languageCode === language)?.value ?? '';
  }
}

const i18nService = new CoreI18nService(apiService);
export default i18nService;
